import {ApiService} from "../api";
import {AxiosResponse} from "axios";
import {Log} from "../../utils/Log";
import {
    CheckoutResponse,
    FeaturesDTO,
    PlanDTO,
    SubscriptionDTO,
    UpgradeResponse
} from "../../types/DTOs/SubscriptionDTO";

export class SubscriptionAPI extends ApiService {
    private constructor() {
        super();
    }

    async getSubscription(): Promise<SubscriptionDTO> {
        const response: AxiosResponse<SubscriptionDTO> = await this.api.get('/subscriptions');
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async getPlans(): Promise<PlanDTO[]> {
        const response: AxiosResponse<PlanDTO[]> = await this.api.get('/subscriptions/plans');
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async getFeatures(): Promise<FeaturesDTO> {
        const response: AxiosResponse<FeaturesDTO> = await this.api.get('/subscriptions/features');
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async createCheckout(planType: string): Promise<CheckoutResponse> {
        const response: AxiosResponse<CheckoutResponse> = await this.api.post('/subscriptions/checkout', {planType});
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async upgradePlan(planType: string): Promise<UpgradeResponse> {
        const response: AxiosResponse<UpgradeResponse> = await this.api.put('/subscriptions/upgrade', {planType});
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async cancelSubscription(): Promise<void> {
        await this.api.delete('/subscriptions');
        Log.writeLogDebug('Subscription cancelled');
    }
}
